
import { Route, Routes, Navigate } from 'react-router-dom';
import RustCourseLaunchForm from './RustCourseLaunchForm';
import ThankYouPage from './ThankYouPage';
import NotFound from '@/components/pages/NotFound';

const CampaignRouter = () => {
  return (
    <Routes>
      {/* Simple direct route to the form without UUID */}
      <Route path="rust-course-launch" element={<RustCourseLaunchForm />} />
      
      {/* Thank you page */}
      <Route path="rust-course-launch-thank-you" element={<ThankYouPage />} />
      
      {/* Redirect the root campaigns path to the main courses page */}
      <Route path="/" element={<Navigate to="/courses" replace />} />
      
      {/* Catch-all for invalid campaign paths */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default CampaignRouter;
